module.exports = __webpack_public_path__ + "static/media/8.83a42fad.png";